import { Component } from 'react';
import { Filter, SearchMode } from 'model/Filters';
import { addFlux, AddFluxHOCProps } from 'components/wrappers/WithFlux';

interface FiltersProviderState {
  filters: {
    activeFilters: Filter[];
    country: string;
    city: string;
    page: number;
  };
  adults: Filter;
  children: Filter;
  mode: SearchMode;
  isComingSoonCity: boolean;
}

interface FiltersProviderProps{
  children: (e: FiltersProviderState) => any;
}

class FiltersProvider extends Component<FiltersProviderProps & AddFluxHOCProps, FiltersProviderState> {
  state = this.getStateFromStore();

  componentDidMount() {
    this.props.flux.stores.FiltersStore.on('change', this.onStoreChange);
  }

  componentWillUnmount() {
    this.props.flux.stores.FiltersStore.removeListener('change', this.onStoreChange);
  }

  getStateFromStore() {
    const filters = this.props.flux.stores.FiltersStore.getFilters();
    const approvedLocations = this.props.flux.stores.LocationsStore.getApprovedLocations().data;
    const isComingSoonCity = filters.city && filters.country && !!approvedLocations.find(f => f.isComingSoon && f.area === filters.city && f.country === filters.country);
    const adults = filters.activeFilters.find(filter => filter.uid === 'adults');
    const children = filters.activeFilters.find(filter => filter.uid === 'children');
    const mode = this.props.flux.stores.FiltersStore.getSearchMode();
    return { filters, adults, children, mode, isComingSoonCity };
  }

  onStoreChange = () => {
    this.setState(this.getStateFromStore());
  };

  render() {
    return this.props.children({ ...this.state });
  }
}

export default addFlux(FiltersProvider);
